import { Box, Heading, Paragraph } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(Box)`
  height: 710px;
  overflow: hidden;
  position: relative;

  ${({ theme }) => css`
    background-color: ${theme.colors.black};

    ${theme.below.laptop`
      height: 800px;
    `}

    ${theme.below.tabletS`
      height: 880px;
    `}
  `}
`

export const BackgroundImage = styled(ImageWithPlaceholder)`
  height: 100%;
  inset: 0;
  object-fit: cover;
  position: absolute;
  width: 100%;
`

export const Title = styled(Heading)`
  max-width: 750px;
  text-transform: uppercase;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'blog')};

    color: ${theme.newColors.lightOrange};
    line-height: ${theme.typography.desktop.title.large.lineHeight}px;
    margin-bottom: ${theme.newSpaces.md}px;

    ${theme.below.laptop`
      ${theme.getTypography('desktop', 'title', 'title1')};
    `}

    ${theme.below.tablet`
      padding: 0 ${theme.newSpaces.xs}px;
    `}

    ${theme.below.mobileL`
      margin-top: ${theme.newSpaces.sm}px;
      max-width: 200px;
    `}

    ${theme.below.mobileM`
      ${theme.getTypography('mobile', 'title', 'title1')};
    `}
  `}
`

export const Subtitle = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title4')};

    color: ${theme.newColors.lightOrange};
    max-width: 100%;
    text-align: left;
    white-space: pre-line;

    ${theme.below.tablet`
      padding: 0 ${theme.newSpaces.xs}px;
    `}

    ${theme.below.mobileL`
      ${theme.getTypography('mobile', 'body', 'body1')}
    `}
  `}
`

export const TextWrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl6}px;
    z-index: 3;

    ${theme.below.laptop`
      margin-left: ${theme.newSpaces.sm}px;
      margin-top: ${theme.newSpaces.xl3}px;
    `}

    ${theme.below.tablet`
      margin-left: ${theme.newSpaces.xs2}px;
    `}

    ${theme.below.tabletS`
      margin-left: 0;
      padding: 0;
    `}

    ${theme.below.mobileL`
      margin-top: ${theme.newSpaces.md}px;
    `}
  `}
`

export const SideImage = styled(Image)`
  position: absolute;
  z-index: 1;

  ${({ theme }) => css`
    right: ${theme.newSpaces.xs2}%;
    top: ${theme.newSpaces.xs}%;

    ${theme.below.desktopXS`
      right: ${theme.newSpaces.xs}px;
    `}

    ${theme.below.tablet`
      top: ${theme.newSpaces.lg}%;
    `}

    ${theme.below.mobileL`
      top: ${theme.newSpaces.xl2}%;
      height: 270px;
      width: 350px;
    `}
  `}
`
